import moment from "moment";
import { Time } from "./types";

export const isSameOrBefore = (dateA: Time, dateB: Time) =>
  moment(dateA).isSameOrBefore(dateB);

export const isAfter = (a: Time, b: Time) => moment(a).isAfter(moment(b));

export const isBefore = (a: Time, b: Time) => moment(a).isBefore(moment(b));

export const isRecentlyHappened = (
  start: Time,
  target: Time,
  limit: number,
) => {
  const startTime = moment(start);
  const targetTime = moment(target);
  const timeLimit = moment(startTime).add(-1 * limit, "minutes");

  return targetTime.isAfter(timeLimit);
};
